import React from 'react';
import { Check, Shield, Zap, Settings, Star, TrendingUp, CreditCard, Send, Lock, Store, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  icon: Shield,
  title: 'Diseño Premium',
  desc: 'Mobile-first y optimizado'
}, {
  icon: Star,
  title: 'Credibilidad',
  desc: 'Reseñas y galería de proyectos'
}, {
  icon: TrendingUp,
  title: 'Crecimiento',
  desc: 'SEO Local y Google Business'
}];
export function PricingSection() {
  return <section id="servicios" className="py-24 bg-dark relative" data-id="element-275" data-mp="1s82eif0lai7i">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-276" data-mp="1x8gmxy63ru62"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-277" data-mp="2up3y81vvxxy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-278" data-mp="2ws3pjsu95fv">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-279" data-mp="1hodby0bn79o3">
            Todo Lo Que Necesitas. <br className="hidden md:block" data-id="element-280" data-mp="1crep82ub64zx" />
            <span className="text-gold" data-id="element-281" data-mp="17s21lfvm4twa">Un Solo Pago.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-282" data-mp="25faggs13z4pb">
          {/* Main Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-gradient-to-br from-dark-100 to-dark-200 rounded-3xl border-2 border-gold p-8 md:p-10 shadow-[0_0_40px_rgba(212,175,55,0.15)] relative overflow-hidden" data-id="element-283" data-mp="20gpg8sluwl0v">
            <div className="absolute top-0 right-0 bg-gold text-dark font-bold px-6 py-2 rounded-bl-2xl text-sm uppercase tracking-wider z-10" data-id="element-284" data-mp="hit6n9qh5y8k">
              Oferta Principal
            </div>

            <div className="relative -mx-8 md:-mx-10 -mt-8 md:-mt-10 mb-8 rounded-t-3xl overflow-hidden" data-id="element-285" data-mp="7ik5dhhmlmmb">
              <img src="https://cdn.magicpatterns.com/uploads/joXRLUuV19avwWiRtVmmjh/heylloyd-image-1782678468852.png" alt="Ejemplo de website profesional para contratistas mostrado en una laptop" className="w-full h-64 md:h-72 object-cover object-[center_38%]" data-id="element-286" data-mp="chn82va4vgr4" />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-100 via-dark-100/20 to-transparent" data-id="element-287" data-mp="3l0bc5airyt5t"></div>
            </div>

            <div className="mb-8" data-id="element-288" data-mp="3by22snz8t5u0">
              <h3 className="flex items-center gap-2 text-xl font-bold text-white mb-4" data-id="element-289" data-mp="3byv4hajch55a">
                <Zap className="w-5 h-5 text-gold" data-id="element-290" data-mp="3fznew73ydg35" />
                WEBSITE COMPLETO
              </h3>
              <div className="flex items-baseline mb-2" data-id="element-291" data-mp="2xc4od30yp7zn">
                <span className="text-6xl font-extrabold text-gold" data-id="element-292" data-mp="2sc08nf7vohah">$250</span>
                <span className="text-gray-400 ml-2 font-medium" data-id="element-293" data-mp="2se38ss2qvqsx">
                  pago único
                </span>
              </div>
            </div>

            <div className="space-y-4 mb-8" data-id="element-294" data-mp="31cf3p6an9ar6">
              {['Solo $125 para empezar (50%)', 'Resto al entregar tu website', 'Sin contratos ni mensualidades', 'Listo en menos de 72 horas'].map((text, i) => <div key={i} className="flex items-center gap-3" data-id="element-295" data-mp="3p2ix6ku4bu4g" data-mpi={i}>
                  <div className="bg-gold/20 p-1 rounded-full shrink-0" data-id="element-296" data-mp="3l0ny7mzntstu">
                    <Check className="w-4 h-4 text-gold" data-id="element-297" data-mp="3l1h6wti6isem" />
                  </div>
                  <span className="text-white font-medium" data-id="element-298" data-mp="2vudnabyyvrq">{text}</span>
                </div>)}
            </div>

            <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="block w-full py-4 text-center bg-gold hover:bg-gold-400 text-dark font-bold rounded-xl transition-colors" data-id="element-299" data-mp="3tz9f7dphgzsi">
              EMPEZAR AHORA
            </a>

            {/* Payment methods */}
            <div className="mt-6 pt-6 border-t border-white/10" data-id="element-300" data-mp="vo65pj5eximj">
              <div className="flex items-center justify-center gap-2 text-gray-400 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-301" data-mp="3v54ak6dxkrsw">
                <Lock className="w-3.5 h-3.5 text-gold" data-id="element-302" data-mp="31bw5ha4w3nu" />
                Métodos de pago seguros
              </div>
              <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-303" data-mp="7ylksupp8bam">
                <div className="flex items-center gap-2 bg-dark-300/60 border border-white/10 rounded-xl px-4 py-2.5" data-id="element-304" data-mp="d0kns3hj1671">
                  <Send className="w-4 h-4 text-gold" data-id="element-305" data-mp="1jh64x86z7uyt" />
                  <span className="text-white font-semibold text-sm" data-id="element-306" data-mp="1od3khcaf0xaj">
                    Zelle
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-dark-300/60 border border-white/10 rounded-xl px-4 py-2.5" data-id="element-307" data-mp="38ya00os413yk">
                  <CreditCard className="w-4 h-4 text-gold" data-id="element-308" data-mp="2z6e0raeaf7sr" />
                  <span className="text-white font-semibold text-sm" data-id="element-309" data-mp="2z4t7rp7mfwx0">
                    Tarjeta
                  </span>
                  <span className="text-gray-500 text-xs" data-id="element-310" data-mp="2u5glb5knwruy">vía Stripe</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Features & Maintenance */}
          <div className="space-y-6" data-id="element-311" data-mp="2l8pdxx0ntql2">
            <div className="grid gap-4" data-id="element-312" data-mp="2g706ssgk5x29">
              {features.map((feat, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="bg-dark-100 p-5 rounded-2xl border border-white/5 flex items-center gap-4" data-id="element-313" data-mp="2b8oumb2sjagv" data-mpi={i}>
                  <feat.icon className="w-8 h-8 text-gold shrink-0" data-id="element-314" data-mp="1tx1ipmvdu14l" />
                  <div data-id="element-315" data-mp="1yyz3wmncf606">
                    <h4 className="text-white font-bold" data-id="element-316" data-mp="1yw4o58f9y9d3">{feat.title}</h4>
                    <p className="text-gray-400 text-sm" data-id="element-317" data-mp="2mp36qrspj1q4">{feat.desc}</p>
                  </div>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="bg-dark-200 rounded-2xl border border-white/10 p-6 flex items-center justify-between" data-id="element-318" data-mp="2dndgvqeh4aug">
              <div data-id="element-319" data-mp="tqy0xv3c2tif">
                <div className="inline-flex items-center gap-2 text-gray-400 font-bold uppercase text-xs mb-1" data-id="element-320" data-mp="trfswfiyqlkj">
                  <Settings className="w-4 h-4" data-id="element-321" data-mp="18ogo4t0d4ynr" /> Opcional
                </div>
                <h4 className="text-white font-bold" data-id="element-322" data-mp="13pdjh9oaougb">Mantenimiento</h4>
                <p className="text-gray-400 text-sm" data-id="element-323" data-mp="13n9espiknrez">
                  Actualizaciones y soporte
                </p>
              </div>
              <div className="text-right" data-id="element-324" data-mp="b0ycnafbhig2">
                <div className="text-2xl font-bold text-white" data-id="element-325" data-mp="b29jjj4276be">$30</div>
                <div className="text-xs text-gray-500" data-id="element-326" data-mp="pqe1ulz79ftn">/ mes</div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Other businesses note */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 bg-dark-100 border border-gold/20 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left" data-id="element-327" data-mp="3tdw7x415zn3w">
          <div className="flex items-center gap-4" data-id="element-328" data-mp="3cwk1cywu8yjg">
            <div className="shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gold/15 text-gold" data-id="element-329" data-mp="3gwkjatj5brv9">
              <Store className="w-6 h-6" data-id="element-330" data-mp="3lum2rfkhht79" />
            </div>
            <div data-id="element-331" data-mp="3qt71fak384tl">
              <h4 className="text-white font-bold" data-id="element-332" data-mp="3qsnt8lk8ousr">
                ¿Tienes otro tipo de negocio?
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-333" data-mp="3vlgxz9fpk34u">
                También creamos websites para cualquier negocio. Pregúntanos sin
                compromiso.
              </p>
            </div>
          </div>
          <a href="https://wa.me/447311754270?text=Hola,%20me%20interesa%20un%20website%20para%20mi%20negocio" target="_blank" rel="noopener noreferrer" className="shrink-0 inline-flex items-center gap-2 py-3 px-6 bg-gold/10 hover:bg-gold hover:text-dark text-gold font-bold rounded-xl border border-gold/30 transition-colors" data-id="element-334" data-mp="8dwjiqhjf1md">
            Pregúntanos
            <ArrowRight className="w-4 h-4" data-id="element-335" data-mp="1jxbsyx0s4zg0" />
          </a>
        </motion.div>
      </div>
    </section>;
}